import React, { useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./DateRange.css";
import { calender_icon } from "../../assets/img";

const DateRange = ({ fromDate, onChange }) => {

  const disableScroll = () => {
    document.documentElement.style.overflow = "hidden"; // <html>
    document.body.style.overflow = "hidden";
  };

  const enableScroll = () => {
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
  };



  return (
    <div className="d-flex ac-js position-relative">
      <div className="d-flex ac-js calender-input w-100">
        <img
          src={calender_icon}
          className="calender-icon mx-2"
          alt="calendar"
          onClick={() => document.getElementById("fromDatePicker").focus()}
        />

        <DatePicker
          id="fromDatePicker"
          selected={fromDate}
          onChange={(date) => onChange(date)}
          dateFormat="dd-MM-yyyy"
          placeholderText="Select Date"
          maxDate={new Date()}
          highlightDates={[new Date()]}
          dayClassName={(date) => date.toDateString() === new Date().toDateString() ? 'today-highlight' : undefined}
          withPortal
          className="date-input"
          onFocus={(e) => (e.target.readOnly = true)}
          onCalendarOpen={disableScroll}
          onCalendarClose={enableScroll}
        />
      </div>

      <div style={{ color: 'white', fontWeight: '600' }} className="search-btn f2">
        Search
      </div>
    </div>
  );
};

export default DateRange;
